import { useEffect, type ReactNode } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { useAuthStore } from '@/stores/auth.store';

interface AuthGuardProps {
  children: ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { userInfo, loading } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !userInfo) {
      navigate({ to: '/', replace: true });
    }
  }, [loading, navigate, userInfo]);

  if (loading || !userInfo) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-text-secondary">Loading...</div>
      </div>
    );
  }

  if (userInfo.role !== 'platform_admin' && userInfo.role !== 'org_admin') {
    return (
      <div className="flex h-screen flex-col items-center justify-center gap-3">
        <div className="text-lg font-semibold text-red-600">Access Denied</div>
        <div className="text-sm text-gray-500">This portal is restricted to platform and organization administrators.</div>
      </div>
    );
  }

  return <>{children}</>;
}
